import { gql } from '@generated/gql';

const basketGuardQuery = gql(`
  query BasketGuard($id: ID!) {
    basket(id: $id) {
      id
      details {
        isExistingCustomer
        submittedAt
      }
    }
  }
`);

export { basketGuardQuery };
